import { FormErrors } from 'redux-form'
import { isEmpty, pickBy } from 'lodash-es'
import { isValidEmail } from 'shared/helpers/utils'
import { IUserFormValues } from './UserForm.types'
import { ParseError, parsePhoneNumberFromString } from 'libphonenumber-js'

export default function validate (values: IUserFormValues): FormErrors<IUserFormValues, string> {
  const { first_name, last_name, email, user_name, permissions, accounts, primary_account, mode, phone, saml_username, users, user, language, access_scope } = values
  const errors: FormErrors<IUserFormValues, string> = {}
  const required: string = 'common.form.validation.required'
  const unique: string ='notifications.exceptions.USERNAME_EXISTS'
  const invalidUserName: string = 'common.form.validation.invalidUserName'
  const primary: string = 'Primary account' + ' ' + primary_account + ' ' + 'cannot be changed'
  const acc = ['']
  if (!access_scope) {
    if (!accounts) {
      errors.accounts = required
    }
  }
  if (user_name !== undefined) {
    if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(user_name)) {
      if (/[!#$%^&*()=[\]{};':"\\|,<>/?\s]+/.test(user_name)) {
        errors.user_name = invalidUserName
      }
    }
  if (users !== undefined && users[0] !== undefined) {
    if (mode === 'edit' && user !== undefined && users.find(u => u.user_name.toLowerCase().trim() === user_name.toLowerCase().trim() && user.id !== u.id)) {
      errors.user_name = unique
    } 
    if (mode !== 'edit' && users.find(user => user.user_name.toLowerCase().trim() === user_name.toLowerCase().trim())) {
      errors.user_name = unique
    }
  }
}
  if (accounts !== undefined && mode === 'edit') {
    accounts.forEach(account => {
      acc.push(account.name)
    })
    if(!acc.includes(primary_account ? primary_account : '')){
      errors['accounts'] = primary
    }
  }

  if (!first_name) {
    errors['first_name'] = required
  }

  if (!last_name) {
   errors['last_name'] = required
  }
  
  if (!email) {
    errors.email = required
  } else if (!isValidEmail(email)) {
    errors.email = 'common.form.validation.invalidEmail'
  }

  if(!user_name) {
    errors.user_name = required
  }
  if(!saml_username) {
    errors.saml_username = required
  }
  if (isEmpty(pickBy(permissions, p => p))) {
    errors.permissions = required
  }
  if (!language) {
    errors.language = required
  }

  if (phone) {
    const countries = ['CU', 'IR', 'SY', 'KP']
    try {
      const phoneNumber = parsePhoneNumberFromString(phone)
      if (phoneNumber && phoneNumber.country && countries.includes(phoneNumber.country)) {
        errors.phone = 'common.form.validation.invalidPhone'
      }
    } catch (error) {
      if (error instanceof ParseError) {
        // Not a phone number, non-existent country, etc.
        console.error(error.message)
      } else {
        console.error(error.message)
      }
    }
  }
  return errors
}
